import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import PdfIcon from "../../../imgs/pdf-icon.svg";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

import * as fetch from "./../../../network/fetch";

import State from "../State";

const Step1Form = () => {
  const navigate = useNavigate();
  const dateInputRef = useRef(null); // Définir le nombre total d'étapes et l'étape actuelle
  const total_steps = 2; // Par exemple, s'il y a 5 étapes au total
  const current_step = 1; // Étape actuelle
  const [txUrl, setTxUrl] = useState("");

  // State for form fields
  const [formData, setFormData] = useState({
    documentName: "", // Nom du document
    documentDescription: "", // Description du document
    attachedFiles: [], // Fichiers joints
    documentDate: new Date().toISOString().split("T")[0],
    convertedDate: "", // Date du document
    isConfidential: false, // Toggle: Confidentialité
    isVerified: false, // Toggle: Vérification
    isPublic: false, // Toggle: Public
    hasLegalApproval: false, // Toggle: Approbation légale
    storage: "", // Stockage (Cloud décentralisé, AWS, Local)
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    if (type === "file") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: Array.from(files), // Convert file list to array
      }));
    } else if (type === "radio") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value, // Store the selected value of the radio button
      }));
    } else if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked, // Store the boolean value (checked or not)
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value, // Store the value of the input
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.documentName &&
      formData.documentDescription &&
      formData.attachedFiles.length > 0
    ) {
      setLoading(true);

      // Construire un objet FormData pour envoyer le fichier avec les données
      const documentData = new FormData();
      const docId =
        Math.floor(Math.random() * 1000000) +
        1 +
        "-" +
        Math.floor(Math.random() * 1000000) +
        1 +
        "-" +
        Math.floor(Math.random() * 1000000) +
        1;
      documentData.append("docId", docId);
      documentData.append("docName", formData.documentName);
      documentData.append("description", formData.documentDescription);
      documentData.append("timestamp", formData.documentDate);
      documentData.append("docType", formData.attachedFiles[0].type); // Type MIME du premier fichier
      documentData.append("author", "Author Name"); // Mettre à jour avec l'auteur réel
      documentData.append("file", formData.attachedFiles[0]);

      try {
        // Appel API pour soumettre le document à notariser
        const response = await fetch.notarizeDocument(documentData);

        if (response.success) {
          // Redirection vers l'étape suivante
          //navigate("/notarization/step2", { replace: true });
          console.log("=== response === Step1Form.js === key: 423415 ===");
          console.dir(response, { depth: null, colors: true });
          console.log("=================================");

          setTxUrl(response.data.tx_uri);

          let responseDocumentData = {
            id: docId,
            documentName: formData.documentName,
            documentDescription: formData.documentDescription,
            documentDate: formData.documentDate,
            documentAuthor: "Author Name",
            ...response.data,
            modifications: [],
          };

          State.documents.push(responseDocumentData);

          const resp2 = await fetch.fetchDocumentMetadata(docId);

          if (resp2.success) {
            console.log("=== resp2 === Step1Form.js === key: 033264 ===");
            console.dir(resp2, { depth: null, colors: true });
            console.log("=================================");
          }

          setFormData({
            documentName: "", // Nom du document
            documentDescription: "", // Description du document
            attachedFiles: [], // Fichiers joints
            documentDate: new Date().toISOString().split("T")[0],
            convertedDate: "", // Date du document
            isConfidential: false, // Toggle: Confidentialité
            isVerified: false, // Toggle: Vérification
            isPublic: false, // Toggle: Public
            hasLegalApproval: false, // Toggle: Approbation légale
            storage: "", // Stockage (Cloud décentralisé, AWS, Local)
          });

          setTutorialSteps(submitedStep);
          setTutorialStep(0);
        } else {
          alert("Une erreur est survenue lors de la soumission du document.");
        }
      } catch (error) {
        console.error("Erreur lors de la notarisation du document:", error);
        alert("Une erreur est survenue. Veuillez réessayer.");
      } finally {
        setLoading(false);
      }
    } else {
      alert("Veuillez remplir tous les champs obligatoires.");
    }
  };

  const isFormValid = () => {
    return (
      formData.documentName &&
      formData.documentDescription &&
      formData.attachedFiles.length > 0
    );
  };

  const handleFileSelect = () => {
    document.getElementById("file-input").click();
  };

  const solutionNextStep = (e) => {
    e.preventDefault();
    navigate("/notarisation/step2", {
      replace: true,
    });
    return;
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialStep, setTutorialStep] = useState(0);
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données (1/4)</p>
          <p>
            En tant que notaire chargé de l'enregistrement des transactions
            immobilières, vous devez téléverser le document officiel de la vente
            sur la blockchain afin de le notariser.
          </p>
        </>
      ),
      position: { top: "120px", left: "50%", transform: "translateX(-50%)" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Confidentialité (2/4)</p>{" "}
          <p>
            A titre démonstratif, vous pouvez choisir de cacher certaines
            informations aux autres acteurs afin d’en assurer la
            confidentialité.
          </p>
        </>
      ),
      showArrow: "right",
      position: { top: "100px", right: "35%", width: "500px" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Ajouter un document (3/4)</p>{" "}
          <p>
            Vous pouvez documenter votre rapport en téléchargeant un document.
          </p>
        </>
      ),
      showArrow: "left",
      position: { top: "400px", left: "40%", width: "500px" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Choix du stockage (4/4)</p>{" "}
          <p>
            À titre démonstratif, vous pouvez choisir où seront stockées vos
            données. Pour plus d’informations sur les types de stockage,
            consultez les questions ci-dessous.
          </p>
        </>
      ),
      showArrow: "left",
      closeLabel: "hidden",
      position: { top: "605px", left: "43%", width: "350px" },
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);
  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">
            Vos informations ont été enregistrées avec succès
          </p>
          <p>
            Vous avez enregistré votre document. Celui-ci est désormais notarié
            sur la blockchain, garantissant son authenticité et son intégrité.
            Cliquez sur le bouton ci-dessous pour consulter les informations
            disponibles
          </p>
          <p>
            {" "}
            <b>
              Vous pouvez soumettre d’autres documents ou passer à l’étape suivante.
            </b>
          </p>
        </>
      ),
      closeLabel: "Enregistrez un nouveau document",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e) => {
        solutionNextStep(e);
      },
      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  return (
    <form onSubmit={handleSubmit} className="container form-esg-1">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>

      {/* Affichage du popup tutoriel */}
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={
            tutorialSteps[tutorialStep].handleNextTutorialStep ||
            handleNextTutorialStep
          }
          onClose={handleCloseTutorial}
          txUrl={txUrl}
          showArrow={tutorialSteps[tutorialStep].showArrow || false}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}

      <div className="fields-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-switch-main">
            <p className="form-switchs-label">Données confidentielles</p>
          </div>
          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="documentDate" className="form-label">
                Date du dépôt
              </label>
              <input
                type="date"
                className="form-control"
                id="documentDate"
                name="documentDate"
                value={formData.documentDate}
                onChange={handleChange}
                placeholder="jj/mm/aaaa"
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                ref={dateInputRef}
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Date Icon"></img>
              </span>
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isConfidential"
                name="isConfidential"
                checked={formData.isConfidential}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="documentName" className="form-label">
                Nom du document
              </label>
              <input
                type="text"
                className="form-control"
                id="documentName"
                name="documentName"
                value={formData.documentName}
                onChange={handleChange}
                required
                placeholder="Ex: Contrat de vente"
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isVerified"
                name="isVerified"
                checked={formData.isVerified}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="documentDescription" className="form-label">
                Description
              </label>
              <input
                type="text"
                className="form-control"
                id="documentDescription"
                name="documentDescription"
                value={formData.documentDescription}
                onChange={handleChange}
                required
                placeholder="Ex: Ce document concerne la vente d'un terrain."
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isPublic"
                name="isPublic"
                checked={formData.isPublic}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="file-wrapper-main">
            <div className="fields-main-item">
              <div className="form-field file-wrapper">
                <label htmlFor="attachedFiles" className="form-label">
                  Ajouter un document
                </label>
                <button
                  type="button"
                  className="btn btn-primary choose-file"
                  onClick={handleFileSelect}
                >
                  Ajouter
                </button>
                <input
                  type="file"
                  id="file-input"
                  name="attachedFiles"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleChange}
                />
              </div>

              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="hasLegalApproval"
                  name="hasLegalApproval"
                  checked={formData.hasLegalApproval}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="file-preview">
              {formData.attachedFiles.map((file, index) => (
                <div key={index} className="file-preview-item">
                  <span className="pdf-icon">
                    <img src={PdfIcon} alt="Icône PDF"></img>
                  </span>
                  <span>{file.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="fields-main-item radios-main">
            <div className="form-field mb-0">
              <label htmlFor="storage" className="form-label">
                Choix du stockage
              </label>
            </div>

            <div className="form-field">
              <div className="form-check custom-radio">
                <input
                  className="form-check-input"
                  type="radio"
                  id="opt1"
                  name="storage"
                  value="cloud"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="opt1">
                  Cloud décentralisé
                </label>
              </div>

              <div className="form-check custom-radio">
                <input
                  className="form-check-input"
                  type="radio"
                  id="opt2"
                  name="storage"
                  value="aws"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="opt2">
                  AWS
                </label>
              </div>

              <div className="form-check custom-radio">
                <input
                  className="form-check-input"
                  type="radio"
                  id="opt3"
                  name="storage"
                  value="local"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="opt3">
                  Local
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="btn-wrapper" style={{ margin: 0 }}>
          {!loading && (
            <>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isFormValid()}
              >
                Enregistrer le document
              </button>

              <button
                className="btn btn-primary"
                onClick={solutionNextStep}
                disabled={!State.documents.length || tutorialStep >= 0}
                style={{ marginLeft: "10px" }}
              >
                Etape suivante
              </button>
            </>
          )}
          {loading && (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
        <div className="btn-wrapper"></div>
      </div>
    </form>
  );
};

export default Step1Form;
